import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import i18n from "i18n";
import { AuthService } from "services/AuthService";
import { ProductService } from "../../../services/ProductService"; 
import AdminLayout from "../../../components/MainApp/layouts/DesktopLayout";
import ExtraMenuItem from "../../../components/MainApp/layouts/ExtraMenuItem";
import Loader from "components/MainApp/atoms/Loader";
import { step0 } from "./data/step0";
import { step1 } from "./data/step1";
import styles from "./ExtraMenu.module.scss";
import packageJson from "./../../../../package.json";
import { EventRepository } from "helpers/EventRepository"; 

const headerOptions = [];

export const ExtraMenuView = (props) => {
  const [permissions, setPermissions] = useState([]);
  const [step, setStep] = useState(step0);
  const [clickCount, setClickCount] = useState(0);
  const [showButton, setShowButton] = useState(false);
  const [businessId, setBusinessId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [cacheCleared, setCacheCleared] = useState(false);
  const steps = [step0, step1];

  useEffect(() => {
    setPermissions(AuthService.getPermissions());
    if (props.match.params.stepNumber) {
      goTo(props.match.params.stepNumber);
    }

    const currentBusinessId = AuthService.getCurrentBusinessId();

    if (currentBusinessId) {
      setBusinessId(currentBusinessId);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, []);

  const goTo = (stepNumber) => {
    setStep(steps[stepNumber]);
  };

  const handleVersionClick = () => {
    if (!showButton) {
      setClickCount((prevCount) => {
        const newCount = prevCount + 1;
        if (newCount >= 5) {
          setShowButton(true);
        }
        return newCount;
      });
    }
  };

  const handleClearCache = async () => {
    if (!businessId) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await ProductService.clearProductsCache(businessId);
      if (response.message === 'Cache key deleted') {
        EventRepository.notificationSend({
          label: i18n.t("products.cache.cleared.success"),
          type: "success"
        });
      } else {
        EventRepository.notificationSend({
          label: i18n.t("products.cache.cleared.error"),
          type: "error"
        });
      }
    } catch (error) {
      EventRepository.notificationSend({
        label: i18n.t("products.cache.cleared.connection.error"),
        type: "error"
      });
    } finally {
      setIsLoading(false);
      setShowButton(false);
      setClickCount(0);
    }
  };

  const content = (
    <div className={styles["extra-menu-content"]}>
      <div className={styles["extra-menu-list"]}>
        {step.items
          .filter((i) => {
            return permissions.includes(i.permission) || i.permission === "all";
          })
          .map((item) => {
            if (item.to) {
              if (item.to == "/admin/businesses" && !AuthService.isYaxAdmin()) {
                return;
              }
              return (
                <NavLink key={item.title} to={item.to}>
                  <ExtraMenuItem key={item.title} title={item.title} arrow={item.arrow} />
                </NavLink>
              );
            } else {
              return (
                <div key={item.title} onClick={() => goTo(item.toStep)}>
                  <ExtraMenuItem key={item.title} title={item.title} arrow={item.arrow} />
                </div>
              );
            }
          })}
        {step.headerTitle == i18n.t("more.options") && (
          <>
            <div className={styles["extra-menu-logout"]} onClick={() => AuthService.logout()}>
              <ExtraMenuItem title={i18n.t("sign.out")} arrow={false} />
            </div>
            <span className={styles["version-container"]} onClick={handleVersionClick}>
              v {packageJson.version}
            </span>
            {showButton && (
              isLoading ? (
                <Loader />
              ) : (
                <button
                  className={styles["delete-cache-button"]}
                  onClick={handleClearCache}
                  disabled={loading}
                >
                  {loading ? "Loading..." : i18n.t("clear.products.cache")}
                </button>
              )
            )}
          </>
        )}
      </div>
    </div>
  );

  return (
    <div className={styles["extra-menu-container"]}>
      <AdminLayout
        headerTitle={i18n.t(step.headerTitle)}
        headerOptions={headerOptions}
        content={content}
        navHidden={step.navHidden}
        goBackFunc={
          step.headerTitle === i18n.t("more.options")
            ? null
            : step.goBackTo === undefined
            ? null
            : () => goTo(step.goBackTo)
        }
      ></AdminLayout>
    </div>
  );
};

export default ExtraMenuView;
